import { Box, Image } from "@chakra-ui/react";
import React from "react";

import { Link } from "react-router-dom";
import { COMMON_WEB_PATH } from "../../../constant";
import useCheckLogin from "../../../hook/useCheckLogin";
import { useDispatch } from "react-redux";
import { openLanguagePop } from "../../../redux/action/member/memberAction";

const LanguageButton = () => {
  const { isLogin, isMachineDomain, isMachineUser } = useCheckLogin();

  const dispatch = useDispatch();

  const onOpen = () => {
    dispatch(openLanguagePop());
  };

  return (
    <Box
      onClick={onOpen}
      position="relative"
      cursor="pointer"
      display="flex"
      alignItems={"center"}
      justifyContent={"center"}
      shadow="sm"
    >
      <Image
        src={`${COMMON_WEB_PATH}/911TW/languageICONcircle.webp`}
        height={{
          base: "30px",
          md: isMachineUser ? "70px" : "50px",
          //xl: "50px",
          xl: isMachineUser ? "70px" : "50px",
        }}
        //minW="50px"
        minW={{
          base: "30px",
          md: isMachineUser ? "70px" : "50px",
        }}
        maxW={{
          base: "30px",
          md: isMachineUser ? "70px" : "50px",
        }}
      />
    </Box>
  );
};

export default LanguageButton;
